import { render, staticRenderFns } from "./GeneralPersonDetails.vue?vue&type=template&id=24ae0a7c"
import script from "./GeneralPersonDetails.vue?vue&type=script&lang=ts"
export * from "./GeneralPersonDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports